import api from './api';

/** Roles de usuário - usar enum para evitar valores inválidos */
export enum UserRole {
  SUPER_ADMIN = 'super_admin',
  ADMIN = 'admin',
  CLINICA = 'clinica',
  COMUM = 'comum',
}

export interface User {
  id: number;
  cpf?: string;
  email: string;
  name: string;
  phone?: string;
  role?: UserRole;
  cnpj?: string;
  logo_url?: string;
}

export interface AuthResponse {
  access_token: string;
  user: User;
  responsible: any;
}

export interface LoginResponse {
  auth_url: string;
  mock_mode?: boolean;
}

export interface RegisterRequest {
  email: string;
  password: string;
  cpf: string;
  name: string;
}

export interface CpfLoginRequest {
  cpf: string;
  password: string;
}

export const authService = {
  async login(): Promise<LoginResponse> {
    const response = await api.get('/auth/login');
    return response.data;
  },
  
  async loginWithCpf(cpf: string, password: string): Promise<AuthResponse> {
    const response = await api.post('/auth/login-cpf', { cpf, password });
    return response.data;
  },
  
  async register(data: RegisterRequest): Promise<AuthResponse> {
    const response = await api.post('/auth/register', data);
    return response.data;
  },
  
  async getMockUsers(): Promise<any[]> {
    const response = await api.get('/auth/mock/users');
    return response.data.users;
  },
  
  async mockLogin(userIdOrCpf: number | string): Promise<AuthResponse> {
    // Se for número, usar como user_id, senão usar como CPF
    const payload = typeof userIdOrCpf === 'number' 
      ? { user_id: userIdOrCpf }
      : { cpf: userIdOrCpf };
    const response = await api.post('/auth/mock/login', payload);
    return response.data;
  },

  async getCurrentUser(): Promise<{ user: User }> {
    const response = await api.get('/auth/me');
    return response.data;
  },

  async updateProfile(data: { name?: string; email?: string; phone?: string; logo_url?: string }): Promise<{ user: User }> {
    const response = await api.put('/auth/profile', data);
    return response.data;
  },

  async changePassword(currentPassword: string, newPassword: string): Promise<void> {
    await api.post('/auth/change-password', { current_password: currentPassword, new_password: newPassword });
  },

  async forgotPassword(email: string): Promise<{ message: string }> {
    const response = await api.post('/auth/forgot-password', { email });
    return response.data;
  },

  async resetPassword(token: string, newPassword: string): Promise<{ message: string }> {
    const response = await api.post('/auth/reset-password', { token, new_password: newPassword });
    return response.data;
  },

  async logout(): Promise<void> {
    await api.post('/auth/logout');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },
};
